module.exports = __webpack_public_path__ + "static/img/pof.94c7eb6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/pof.png
// module id = +S/y
// module chunks = 1